function getProductSelector() {
  return $('#product-select-option-0');
}

function selectNoRegion() {
  var selector = getProductSelector();
  var selectorDOM = selector[0];
  
  selectorDOM.selectedIndex = -1;
  selector.change();
}

function newRegion(region) {
  var selector = getProductSelector();
  var selectorDOM = selector[0];
  for (var i = 0; i < selectorDOM.options.length; i++) {
    if (selectorDOM.options[i].text == region.name) {
      selectorDOM.selectedIndex = i;
      selector.change();
      return;
    }
  }
  // Hmm. Didn't find the region name.
  selectNoRegion();
} 

function monitorPostcode() {
  pc = $("#postcode").val().toUpperCase();

  for (var i = 0; i < regexps.length; i++) {
    var re = regexps[i];
    if (pc.match(re.re) != null) {
      // match! Update the form with the other stuff
      // we now know.
      newRegion(regions[re.rid])
      return;
    }
  }
  // not enough postcode has been entered yet.
  selectNoRegion();
}

function setup() {
  // any time the postcode is changed, check to see if we need
  // to change the delivery region.
  $("#postcode").on("input", null, null, monitorPostcode);
  
  // Disallow the user from setting the delivery region explicitly
  // (an alternative would be to hide this altogether). 
  // getProductSelector().attr('disabled', 'disabled');
  
  
  // In case the postcode is pre-populated (e.g. by the browser),
  // set the delivery region from it. 
  monitorPostcode();
}

$(document).ready(setup);
